import React from "react";
import OfferCard from "./OfferCard";
import RevealOnScroll from "./RevealOnScroll";
import { wonyaOffers } from "../constants/offers";

const OfferGrid = ({ showPricing = false, animated = false }) => (
  <div className="ws-offer-grid">
    {wonyaOffers.map((offer, index) => {
      const card = <OfferCard offer={offer} showPricing={showPricing} />;

      return animated ? (
        <RevealOnScroll
          className="ws-offer-grid__reveal"
          delay={index * 80}
          key={offer.id}
          variant="fade-up"
        >
          {card}
        </RevealOnScroll>
      ) : (
        <React.Fragment key={offer.id}>{card}</React.Fragment>
      );
    })}
  </div>
);

export default OfferGrid;
